<template>
    <v-dialog
        v-model="dialogState"
        :width="width"
    >
        <v-toolbar
            dark
            color="primary"
        >
            <v-toolbar-title></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn
                    icon
                    dark
                    @click="onClose"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <work-space-invite v-if="WORKSPACE_INVITE_TOKEN" :token="WORKSPACE_INVITE_TOKEN" @accept="onAccept" @reject="onReject"></work-space-invite>
    </v-dialog>
</template>

<script>
import WorkSpaceInvite from "../invite/WorkSpaceInvite.vue";
import {mapActions, mapGetters} from "vuex";

export default {
    name: "WorkSpaceInviteDialog",
    components: {WorkSpaceInvite},
    props: {},
    data() {
        return {
        }
    },
    methods: {
        onClose(){
            this.dialogState = false;
            this.RESET_INVITE_WORKSPACE();
        },
        onAccept(data){
            this.LOAD_WORKSPACES();
            this.RESET_INVITE_WORKSPACE();
            this.CHECKOUT(data.work_space_id);
            this.onClose();
        },
        onReject(){
            this.LOAD_WORKSPACES();
            this.RESET_INVITE_WORKSPACE();
            this.onClose();
        },
        ...mapActions('workspaceList', ['LOAD_WORKSPACES', 'RESET_INVITE_WORKSPACE']),
        ...mapActions('dialog', {dialogToggle: 'toggle'}),
        ...mapActions('workspace', ['CHECKOUT']),
    },
    computed:{
        dialogState: {
            get() {
                return this.dialog && this.name === 'WorkSpaceInviteDialog'
            },
            set() {
                this.dialogToggle();
            }
        },
        ...mapGetters('dialog', ['dialog', 'width', 'name']),
        ...mapGetters('workspaceList', ['WORKSPACE_INVITE_TOKEN']),
    }
}
</script>